import API from './API/Main/API';
import { isImpersonating, setImpersonationToken, stopImpersonation } from './API/Main/fetchAPI';
import { impersonate, login, refresh } from './State/identitySlice/accountSlice';
import { resetState } from './resetState';

const localStorageMiddleware = (store: any) => (next: any) => (action: any) => {
	const { dispatch } = store;
	const ls = window.localStorage;

	if (action.type === login.fulfilled.type) {
		if (action.payload.token) {
			API.setToken(action.payload.token);
		}
	}

	if (action.type === refresh.fulfilled.type) {
		if (action.payload.token) {
			API.setToken(action.payload.token);
		}
	}

	if (action.type === impersonate.fulfilled.type) {
		if (action.payload.token) {
			setImpersonationToken(action.payload.token);
			window.location.href = '/dashboard';
		}
	}

	if (action.type === refresh.rejected.type) {
		if (isImpersonating()) {
			stopImpersonation();
			window.location.href = '/dashboard';
			return;
		}
		dispatch(resetState());
	}

	if (action.type === resetState.type) {
		const appVersion = ls.getItem('appVersion');
		const loggedUserId = ls.getItem('userId');
		ls.clear();
		ls.setItem('appVersion', appVersion as string);
		ls.setItem('userId', loggedUserId as string);
		API.setToken('');
	}

	next(action);
};

export { localStorageMiddleware };
